"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PackageEntity_1 = __importDefault(require("./Entity/PackageEntity"));
var PackageApi = /** @class */ (function () {
    function PackageApi(session) {
        this.packageEntity = new PackageEntity_1.default(session);
    }
    PackageApi.prototype.getPackageById = function (queryParams) {
        return this.packageEntity.getPackageById(queryParams);
    };
    PackageApi.prototype.getAllTaskPackages = function (queryParams) {
        return this.packageEntity.getAllTaskPackages(queryParams);
    };
    PackageApi.prototype.deletePackage = function (queryParams) {
        return this.packageEntity.deletePackage(queryParams);
    };
    PackageApi.prototype.createPackage = function (newPackage) {
        return this.packageEntity.createPackage(newPackage);
    };
    PackageApi.prototype.updatePackage = function (updatedPackage) {
        return this.packageEntity.updatePackage(updatedPackage);
    };
    PackageApi.prototype.upsertPackage = function (newPackage) {
        return this.packageEntity.upsertPackage(newPackage);
    };
    return PackageApi;
}());
exports.default = PackageApi;
//# sourceMappingURL=PackageApi.js.map